import React, { useEffect, useState } from "react";
import Navbar from '../Common/Navbar'
import AllBlogs from "./components/AllBlogs";
import BlogsEditor from "./components/BlogsEditor";
import {Footer} from '../Footer/Footer'
import { fetchApi} from '../utlis/axios'
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import Banner from "../Common/Banner";

const Blogs = () => {
  const location=useLocation()
  const [isOpen, setIsOpen] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [latestArticles, setLatestArticles] = useState([]);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();
  const fetchBlogs = async () => {
    // Only fetch if we don't have blogs from location state or blogs array is empty
    if (location.state?.blogs?.length > 0) {
      setBlogs(location.state.blogs);
      setLatestArticles(location.state.latestArticles);
      setTotal(location.state.total);
      return;
    }
    
    setLoading(true);
    try {
      const res = await fetchApi.get("blogs/");
      if (res.status === 200) {
        setBlogs(res.data.results || []);
        setLatestArticles(res.data.results || []);
        setTotal(res.data.count);
      }
    } catch (error) {
      toast.error('Something went wrong')
    } finally {
      setLoading(false);
    }
  };
  const updatesBlogs = async () => {
    try {
      const res = await fetchApi.get("blogs/");
      if (res.status === 200) {
        setBlogs(res.data.results || []);
        setLatestArticles(res.data.results || []);
        setTotal(res.data.count);
      }
    } catch (error) {
      toast.error("Something went wrong")
    } finally {
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchNextBlogs = async (offset) => {
    setLoading(true);
    try {
      const res = await fetchApi.get(`blogs?limt=10&offset=${offset}`);
      if (res.status === 200) {
        setBlogs(res.data.results || []);
        setTotal(res.data.count);
      }
    } catch (error) {
      toast.error('Something went wrong')
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Helmet>
        <title>KWF Blog | Real Stories of Change & Compassion</title>
        <meta name="description" content="Read our blog on how food aid, schooling, housing and clothing initiatives help underprivileged communities find hope and opportunity."/>
      </Helmet>
      <Navbar />
      <Banner title={"Some outstanding Articles"} text={'Welcome to Khadim Welfare Foundation, a place dedicated to supporting '} parent={'blogs'} setOpen={setIsOpen}/>
      <AllBlogs
        setOpen={setIsOpen}
        blogs={blogs}
        totalPages={Math.ceil(total / 10)}
        fetchNextBlogs={fetchNextBlogs}
        loading={loading}
        latestArticles={latestArticles}
      />
      {isOpen && (
        <BlogsEditor
          onClose={() => setIsOpen(false)}
          updateBlogs={updatesBlogs}
        />
      )}
      <Footer />
    </div>
  );
};

export default Blogs;
